import Box from "@material-ui/core/Box";
import { SecureRoute } from "@okta/okta-react";
import React, { useContext, useEffect } from "react";
import { get } from "lodash";
import { BrowserRouter as Router, Route } from "react-router-dom";
import WrappedSecurity from "../security/WrappedSecurity";
import Dashboard from "../pages/Dashboard";
import NewRequest from "../pages/NewRequest";
import ImplicitCallback from '../components/implicit-callback/ImplicitCallback';
import JobSummary from "../pages/JobSummary";
import RequestSummary from "../pages/RequestSummary";
import DeliveryManagement from "../pages/DeliveryManagement";
import UserManagement from "../pages/UserManagement";
import MediaRequest from "../pages/MediaRequest";
import { currentEnvironment, isLocal } from '../constants/Env';
import { APP_CONSTANTS } from '../constants/AppConstants';
import Clarity from '../utils/ClarityUtils';
import { UserContext } from "../context/UserContext";
import ContentFinder from "../pages/ContentFinder";
import { BannerContextProvider } from "../context/BannerContext";

const AppWithRouterAccess = () => {
  const { userRole, userInfo } = useContext(UserContext);

  useEffect(() => {
    Clarity.clarityInit();
    Clarity.setClarityTag('foundryApp', APP_CONSTANTS.APP_NAME);
    Clarity.setClarityTag('env', isLocal ? 'local' : currentEnvironment);
    if (get(userInfo, "sub")) {
      Clarity.setClarityTag('userOktaRole', userRole);
    }
  }, [userRole, userInfo]);

  return (
    <Router>
      <WrappedSecurity>
        <BannerContextProvider>
          <Box style={{ padding: "0px", margin: "0px" }}>
            <SecureRoute path={"/"} exact component={Dashboard} />
            <SecureRoute path="/request" exact component={NewRequest} />
            <SecureRoute path="/mediaRequest" component={MediaRequest} />
            <SecureRoute path="/legacyGmsc" component={ContentFinder} />
            <SecureRoute path="/summary" exact component={JobSummary} />
            <SecureRoute path="/requestSummary" exact component={RequestSummary} />
            <SecureRoute path="/lists" exact component={DeliveryManagement} />
            <SecureRoute path="/users" exact component={UserManagement} />
            <Route path="/implicit/callback" component={ImplicitCallback} />
          </Box>
        </BannerContextProvider>
      </WrappedSecurity>
    </Router>
  );
};
export default AppWithRouterAccess;
